function setVideoSliders(){
    function updateProgressbar(bar, offset, width){
        const percent = offset / width * 100;
        bar.style.width = percent + "%";
    }

    const videoSections = document.querySelectorAll(".videos_section");

    videoSections.forEach(section => {
        const slider = section.querySelector(".videos_scroll");
        const buttonLeft = section.querySelector("button[id*='_videos_button_left']");
        const buttonRight = section.querySelector("button[id*='_videos_button_right']");   
        const progressBar = section.querySelector(".progress-bar-fill");

        let scrollOffset = 0;
        let isScrolling = false;

        if(slider && buttonLeft && buttonRight){
            const scrollStep = section.querySelector(".video").getBoundingClientRect().width + 18;
            const scrollWidth = slider.scrollWidth;
            const scrollMax = (scrollWidth - scrollStep * 3) * -1;

            buttonRight.addEventListener("click", function() {
                if(scrollOffset > scrollMax){
                    scrollOffset -= scrollStep;
                    slider.style.transform = `translateX(${scrollOffset}px)`;
                    updateProgressbar(progressBar, scrollOffset, scrollMax);
                }
            });

            buttonLeft.addEventListener("click", function() {
                if(scrollOffset < 0){
                    scrollOffset += scrollStep;
                    slider.style.transform = `translateX(${scrollOffset}px)`;
                    updateProgressbar(progressBar, scrollOffset, scrollMax);
                }
            });

            slider.addEventListener("wheel", function(e) {
                if (window.innerWidth < 860) return;
                if (isScrolling) return;
                if (Math.abs(e.deltaX) < 10) return;
                e.preventDefault();

                const direction = e.deltaX > 0 ? 1 : -1;
                const step = scrollStep;

                if (direction > 0 && scrollOffset > scrollMax) {
                    scrollOffset -= step;
                    if (scrollOffset < scrollMax) scrollOffset = scrollMax;
                } else if (direction < 0 && scrollOffset < 0) {
                    scrollOffset += step;
                    if (scrollOffset > 0) scrollOffset = 0;
                } else {
                    return;
                }

                slider.style.transform = `translateX(${scrollOffset}px)`;
                updateProgressbar(progressBar, scrollOffset, scrollMax);

                isScrolling = true;
                setTimeout(() => { isScrolling = false; }, 300);
            }, { passive: false });
        }
    });
}
window.addEventListener("load", setVideoSliders)

window.addEventListener("resize",setVideoSliders)